module.exports = __webpack_public_path__ + "img/mail-active.f83850f8.svg";